import * as React from 'react'
import { ReactNode } from 'react'
import { ReactFC } from 'common/types/ReactFC'
import useWindowSize from 'components/util/useWindowSize'
import classNames from 'classnames'
import HeroLogo, { HeroLogoType } from './HeroLogo'
import Icon from 'components/Icon'
import imageResize from 'project/image-proxy-web'

type FullHeightHeroType = {
  theme?: 'light' | 'dark'
  logoColor?: HeroLogoType['color']
  title: ReactNode
  subtitle: ReactNode
  backgroundImage: string
  option?: 1 | 2 | 3
  className?: string
}

const FullScreenHero: ReactFC<FullHeightHeroType> = ({
  backgroundImage,
  className,
  logoColor = 'white',
  option = 1,
  subtitle,
  theme = 'light',
  title,
}) => {
  const size = useWindowSize()
  return (
    <>
      <div
        className={classNames(
          'hero hero--full-screen',
          `hero-full-screen--option${option}`,
          {
            'color-white': theme === 'light',
          },
          className,
        )}
        style={{ backgroundImage: `url('${imageResize(backgroundImage)}')` }}
      >
        <div className='container position-relative h-100 pt-xl-34 pt-md-18 pt-14 px-lg-30'>
          <HeroLogo className='d-block mx-md-0 mx-auto' color={logoColor} />
          <div
            className={
              'd-md-block d-none text-center position-absolute start-0 end-0 bottom-0 pb-xxxl-20 pb-md-10'
            }
          >
            <h1
              className='h1 mb-4'
              dangerouslySetInnerHTML={{ __html: `${title}` }}
            />
            <h2
              className={'text-semibold'}
              dangerouslySetInnerHTML={{ __html: `${subtitle}` }}
            />
            <Icon
              className={'mt-2'}
              name={'arrow-down'}
              width={size.isXlOrHigher ? 38 : 20}
              height={size.isXlOrHigher ? 55 : 29}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default FullScreenHero
